import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { TextField, Box, Button, useTheme } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import request from '@/utils/request';
import Styled from './styles';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const [isRefresh, setIsRefresh] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const { setOpen = () => {}, onConfirm, chooseList, setChooseList } = props;

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  const chooseIdList = useMemo(() => {
    return chooseList?.map((i) => i.id);
  }, [chooseList]);

  const [title, setTitle] = useState('');

  const fetchList = useCallback(() => {
    request('/coupon/queryPage', {
      method: 'POST',
      data: {
        pageNum: pageData.pageNum,
        pageSize: pageData.pageSize,
        title: isSearch ? title : null,
        status: 'NOT_COMPLETE',
        rejectType: 'THIRD_PARTY_COUPON',
      },
    }).then((res) => {
      setCpList(res.data.data);
      setTotal(res.data.total);
      setPages(res.data.pages);
    });
  }, [pageData, isRefresh]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const [cpList, setCpList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        console.log('c', c);

        setChooseList(c);
      },
    },
    {
      align: 'center',
      title: '优惠券名称',
      id: 'title',
      key: 'title',
    },
    {
      align: 'center',
      title: '适用商品',
      id: 'isAllGoods',
      key: 'isAllGoods',
      render: ({ isAllGoods }) => {
        switch (isAllGoods) {
          case 0:
            return '指定适用商品';
          case 1:
            return '所有商品';
          case 2:
            return '不适用商品';
          default:
            return '';
        }
      },
    },
    {
      align: 'center',
      title: '优惠内容',
      id: 'subTitle',
      key: 'subTitle',
    },
    {
      title: '领取人限制',
      align: 'center',
      id: 'memberLimit',
      key: 'memberLimit',
      render: ({ memberLimit }) => {
        return <div>{memberLimit ? '不限' : '会员'}</div>;
      },
    },
    {
      title: '限领次数',
      align: 'center',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 125,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{isLimitMaxCoupons ? '限制' : '不限'}</div>;
      },
    },
    {
      title: '剩余库存',
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 145,
    },
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(chooseList);
    setOpen(false);
  };

  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        {formatMessage({ id: 'comm.action.btn.08' })}
      </Button>
      <Button
        variant="contained"
        type="submit"
        className="btnSubmit button"
        onClick={onSubmit}
      >
        {formatMessage({ id: 'comm.action.btn.07' })}
      </Button>
    </div>
  );
  const handleRestClick = () => {
    setIsSearch(false);
    setTitle('');
    setPageData({ ...pageData, pageNum: 1 });
    setIsRefresh(isRefresh + 1);
  };
  return (
    <Styled theme={theme}>
      <Box
        sx={{
          fontSize: '20px',
          fontWeight: '600',
          color: '#111',
          paddingLeft: '24px',
          marginBottom: '30px',
        }}
      >
        选择优惠券
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 32px',
          gap: '32px',
        }}
      >
        <Box className="coupon-name-wrap">
          <TextField
            sx={{ width: '100%' }}
            className="coupon-name"
            variant="standard"
            onChange={(e) => {
              setTitle(e.target.value);
              setIsSearch(false);
            }}
            value={title}
            label="名称"
            placeholder="请输入"
          />
        </Box>
        <Box
          className="button-group"
          sx={{
            display: 'flex',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            className="reset"
            onClick={handleRestClick}
            startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
          >
            {formatMessage({ id: 'comm.action.btn.06' })}
          </Button>

          <Button
            variant="contained"
            className="search"
            startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => {
              setPageData({ ...pageData, pageNum: 1 });
              setIsRefresh(isRefresh + 1);
              setIsSearch(true);
            }}
          >
            {formatMessage({ id: 'comm.action.btn.01' })}
          </Button>
        </Box>
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="400"
          chooseIds={chooseIdList}
          paging={true}
          columnKey="id"
          hasNext={pageData.pageNum < pages}
          showPagingData={{ status: true, marginTop: '24px' }}
          showPageColor={true}
          pages={pages}
          singleSelect
          np={true}
        ></DataTableNativeML>
        {footContent}
      </div>
    </Styled>
  );
};
